export default __webpack_public_path__ + "static/media/team.f046322c.jpg";